<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div style="min-width:370px;max-width: 100%;">
      <div class="flexStart">
      <p class="tileTitle" style="margin-bottom: 5px;">{{'Learning Content Overview' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
      </div>
   
      <div class="text-center padT30"> 
     
      <div class="text" *ngIf="data_04.length==0">{{'No data' | translate}}</div>
          <div class="chartContainer" disabled [ngClass]="data_04.length==0 ? 'chartDisabled':''">          
          <div id="contentDonut" >{{'Chart' | translate}}</div>
        </div>
      </div>
    
    </div>
    <div class="verticalLine" style="text-align:center;"></div>
    <div  style="width:100%;">
      <div class="text" *ngIf="sumofContentItems[0].content_count==0">{{'No data' | translate}}</div>
      <div class="chartContainer" [ngClass]="sumofContentItems[0].content_count==0 ? 'chartDisabled':''">
      <div style="display: flex;justify-content: space-between;">
       
      <div style="width:100%; margin-top:24px;">

        <div id="contentOverview" class="content" style="height:37px;margin-top: 1px;" [ngClass]="textDir=='rtl'?'marL15':'marR15'" [dir]="textDir">
          <table class="table" [dir]="textDir">
          <thead style="color: #f2f2f2;">
            <tr style="color: #f2f2f2;opacity: 0.6;">             
              <th>{{'Item Type' | translate}}</th>
              <th>{{'No. of Items' | translate}}</th>
              <th>{{'User Count' | translate}}</th>
              <th>{{'Launch Count' | translate}}</th>
              <th>{{'Completions' | translate}}</th>              
            </tr>
          </thead>
          </table>
        </div>
        <div id="contentOverviewBody" class="content" style="display: inline-block;height:250px;overflow-y: auto;scrollbar-width: thin;;margin-top:7px !important;" [ngClass]="textDir=='rtl'?'marL5':'marR5'" [dir]="textDir">
          <table class="table dashed" [dir]="textDir">
           
            <tbody style="background-color: black; font-size:12px;">
              <tr *ngFor="let item of sumofContentItems; let i=index" [attr.data-index]="i">  
                <ng-container >
                <td ><div style="display: inline;font-size: 14px;" [ngClass]="textDir=='rtl'?'pull-right marL5':'pull-left marR5'" class="{{'colorData-'+(i+1)}}"><i class="icon icon-alarm-level5"></i></div><div style="display: inline;">{{item?.id}}</div></td>
              </ng-container> 

                <td class="txtCenter" >{{item?.content_count}}</td>
                <td class="txtCenter" >{{item?.user_count}}</td>
                <td class="txtCenter" >{{item?.launch_count}}</td>
                <td class="txtCenter" >{{item?.complete_count}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


       
      </div>
    </div>
    </div>
    </div>

    <div style="width: 20px;margin-top:2px;text-align: right;">
      <div #contentDropdown class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu">
          <div class="item" tabindex="0" (click)="generateCSV('content-overview')">{{'Export Panel Data(csv)' | translate}}</div>
         <!--  <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div> -->
        </div>
      </div>
    </div>

  </div>
</div>

<br>
<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div style="width:98%">
      <div class="flexStart">
            <p class="tileTitle" style="margin-bottom: 5px;">{{'Content Usage Daily Trend' | translate}}</p>
            <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
         </div>
            <ng-container >
              
            <div style="display: inline-block;width:100%;min-width:700px;">
             <!--  <div class="verticalTxt" style="margin-top:100px;margin-left:20px;">Items Viewed</div>
              <div style="margin-top:-200px;margin-left:30px;text-align: center;color: #181818; font-family: Ericsson Hilda;" id="contentUseDailyTrendChart" [ctlLineChart]='settings_05' [ctlLineData]='data_05'>
            
              </div>  -->
             <div class="padT30">  
              
                 <div class="text" *ngIf="data_05.length==0">{{'No data' | translate}}</div>
                  <div class="chartContainer" disabled [ngClass]="data_05.length==0 ? 'chartDisabled':''">          
                  <div id="contentLinechart" >{{'Chart' | translate}}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
    </div>
        <div style="width: 20px;text-align: right;">
          <div #contenttrenddrop class="dropdown more" data-type="click">
              <button class="btn clickable"><i class="icon icon-more"></i></button>
              <div class="menu right">
                <div class="item" tabindex="0" (click)="generateCSV('content-trend')">{{'Export Panel Data(csv)' | translate}}</div>
               <!--  <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div> -->
                <!-- <hr>
                <div class="item space-between">
                  <div>Settings</div>
                  <div><i class="icon icon-settings"></i></div>
                </div> -->
              </div>
            </div>
      </div>
    </div>
  </div>
<br>

    <div class="tile" [dir]="textDir">
        <div class="row" style="display: flex;justify-content: space-between;">
          <div style="width:97%;display: inherit;">
            <div style="min-width:370px;max-width: 100%;">
            <div class="flexStart">
            
            <p class="tileTitle" style="margin-bottom: 5px;">{{'New Content Uploads' | translate}}</p>
            <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
            </div>
           
            <div class="text-center padT30"> 
            
            <div class="text" *ngIf="data_06.length==0">{{'No data' | translate}}</div>
            <div class="chartContainer" disabled [ngClass]="data_06.length==0 ? 'chartDisabled':''">          
            <div id="contentDonut1" >{{'Chart' | translate}}</div>
          </div>
            </div>
         
          </div>
          <div class="verticalLine"></div>
          <div style="width:100%;">
            <div class="text" *ngIf="sumofNewContentItems[0].content_count==0">{{'No data' | translate}}</div>
            <div class="chartContainer" [ngClass]="sumofNewContentItems[0].content_count==0 ? 'chartDisabled':''">
              <div style="display: flex;justify-content: space-between;">
       
                <div style="width:100%; margin-top:24px;">


              <div id="contentHeader" class="content" style=" margin-left: 10px;height:37px" [dir]="textDir">
                <table class="table" [dir]="textDir">
                <thead style="color: #f2f2f2;opacity: 0.6;">
                  <tr>
                    <th>{{'Item Type' | translate}}</th>
                    <th class="txtCenter">{{'No. of Items' | translate}}</th>
                    <th class="txtCenter">{{'Curriculum Content' | translate}}</th>
                    <th class="txtCenter">{{'Teacher Content' | translate}}</th>
                  </tr>
                </thead>
                </table>
              </div>
              <div id="contentBody" class="content" style="display: inline-block; margin-left: 10px;height:250px;overflow-y: auto;scrollbar-width: thin; margin-top: 7px;" [dir]="textDir">
                <table class="table dashed" [dir]="textDir">
                 
                  <tbody style="background-color: black; font-size:12px;">
                    <tr *ngFor="let item of sumofNewContentItems; let i=index" [attr.data-index]="i">
                    
                      <ng-container >
                        <td ><div style="display: inline;font-size: 14px;" [ngClass]="textDir=='rtl'?'pull-right marL5':'pull-left marR5'" class="{{'colorData-'+(i+1)}}"><i class="icon icon-alarm-level5"></i></div><div style="display: inline;">{{item?.id}}</div></td>
                      </ng-container> 
                      <td class="txtCenter" >{{item?.content_count}}</td>
                      <td class="txtCenter" >{{item?.curriculum_count}}</td>
                      <td class="txtCenter" >{{item?.teacher_count}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
</div>
</div>
            </div>
          </div>
</div>

<div style="width: 20px;text-align: right;">
  <div #contentnewdrop class="dropdown more" data-type="click">
    <button class="btn clickable"><i class="icon icon-more"></i></button>
    <div class="menu right">
      <div class="item" tabindex="0" (click)="generateCSV('content-new')">{{'Export Panel Data(csv)' | translate}}</div>
      <!-- <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div> -->
    </div>
  </div>
</div>


        </div>
      </div>
      

    